import moment from "moment";

import { CommentRead } from "@nens/rana/api-v1";

import { UsePublicationCommentReturn } from "../hooks/use-comment";

import { Comment } from "./comment";

const THREAD_HEADER_OFFSET = 1;

interface CommentListProps {
  selectedCommentThread: CommentRead;
  editCommentMessage: UsePublicationCommentReturn["editCommentMessage"];
  removeCommentMessage: UsePublicationCommentReturn["removeCommentMessage"];
  toggleCommentReaction: UsePublicationCommentReturn["toggleCommentReaction"];
}

export function CommentList(props: CommentListProps) {
  const { selectedCommentThread, editCommentMessage, removeCommentMessage, toggleCommentReaction } =
    props;
  return selectedCommentThread.messages
    .slice(THREAD_HEADER_OFFSET, selectedCommentThread.messages.length)
    .map((message, messageIndex, messages) => {
      const { createdAt, body, deleted } = message;

      if (deleted) return null;

      const lastMessage = messages
        .slice(0, messageIndex)
        .reverse()
        .find((m) => !m.deleted);
      const nextMessage = messages.slice(messageIndex + 1).find((m) => !m.deleted);
      const showDate =
        !lastMessage ||
        moment(lastMessage?.createdAt).format("D MMM YYYY") !==
          moment(message.createdAt).format("D MMM YYYY");

      return (
        <Comment
          key={createdAt.toString() + body + messageIndex}
          message={message}
          lastMessage={lastMessage}
          nextMessage={nextMessage}
          showDate={showDate}
          onEdit={(body: string) =>
            editCommentMessage({
              commentId: selectedCommentThread.id,
              messageIndex: messageIndex + THREAD_HEADER_OFFSET,
              body,
            })
          }
          onRemove={() =>
            removeCommentMessage({
              commentId: selectedCommentThread.id,
              messageIndex: messageIndex + THREAD_HEADER_OFFSET,
            })
          }
          onToggleReaction={(emoji) =>
            toggleCommentReaction({
              commentId: selectedCommentThread.id,
              messageIndex: messageIndex + THREAD_HEADER_OFFSET,
              emoji,
            })
          }
        />
      );
    });
}
